import { prop } from 'ramda';
import { remoteDataToMaybe } from '../lib';

const getMailbox = (remoteUser, mailbox = 'mailbox') => remoteDataToMaybe(remoteUser).cata(
  () => 'User not in success state',
  prop(mailbox),
);

export default getMailbox;
